module.exports = __webpack_public_path__ + "img/026e753.svg";